import { OpenCarts } from '../../orders/openCarts/';
import { OrderStatus } from '../../orders/orderStatus';
/* eslint-disable import/no-cycle */
import OrderDetails from '../../orders/orderDetails/OrderDetails';
import OrderReturns from '../../orders/orderReturns/OrderReturns';
import { ReturnStatusV2 } from '../../orders/returnStatus';
import ReturnDetails from '../../orders/returnDetails/ReturnDetails';

import { allAdminAndStandard, allExceptInvoiceOnly, invoiceAccess } from '../../util/rolePermissions';
import {
  AUSTRALIA_SALES_ORGS,
  CHINA_SALES_ORGS,
  INVOICE_HIDDEN_SALES_ORGS,
  JAPAN_SALES_ORGS
} from '../../util/constants';

const RETURNS_HIDDEN_SALES_ORGS = [...CHINA_SALES_ORGS, ...AUSTRALIA_SALES_ORGS, JAPAN_SALES_ORGS];

const orderRoutes = [
  {
    path: '/orders/open',
    title: 'openCarts.page.title',
    component: OpenCarts,
    nav: true,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  },
  {
    path: '/orders/status',
    title: 'orderstatus.orderStatus',
    component: OrderStatus,
    nav: true,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  },
  {
    path: '/orders/id/:orderId',
    title: 'orderdetails.page.title',
    component: OrderDetails,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  },
  {
    path: '/orders/id/:orderId/shipments',
    title: 'orderdetails.page.title',
    component: OrderDetails,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  },
  {
    path: '/orders/returns/id/:orderId',
    title: 'orderreturns.orderReturns',
    component: OrderReturns,
    nav: false,
    exact: false,
    limitToRoles: allAdminAndStandard,
    hiddenFromSalesOrgs: RETURNS_HIDDEN_SALES_ORGS
  },
  {
    path: '/orders/returns',
    title: 'returnStatus.route',
    component: ReturnStatusV2,
    nav: true,
    exact: true,
    limitToRoles: allAdminAndStandard,
    hiddenFromSalesOrgs: RETURNS_HIDDEN_SALES_ORGS
  },
  {
    path: '/orders/returns/details/id/:submittedReturnId',
    title: 'orderreturns.returnDetails',
    component: ReturnDetails,
    nav: false,
    exact: true,
    limitToRoles: allAdminAndStandard,
    hiddenFromSalesOrgs: RETURNS_HIDDEN_SALES_ORGS
  },
  // Hack to show Orders in nav if only Invoices modal is available
  {
    title: 'Invoices',
    nav: false,
    path: '/invoices',
    limitToRoles: invoiceAccess,
    hiddenFromSalesOrgs: INVOICE_HIDDEN_SALES_ORGS
  }
];

export default orderRoutes;
